//@flow

import React from 'react';
import i18n from 'app/common/lib/i18n';
import millisToMinutesAndSeconds from 'app/common/lib/util/millisToMinutesAndSeconds';
import { Box, Icon, Text } from 'gestalt';

const VIDEO_CAMERA_DIM = 24;

type Props = {
  duration: number,
};

export default function VideoIndicatorIcon({ duration }: Props) {
  return (
    <Box
      alignItems="center"
      color="transparentDarkGray"
      display="flex"
      height={VIDEO_CAMERA_DIM}
      justifyContent="center"
      paddingX={2}
      shape="pill"
    >
      <Icon
        accessibilityLabel={i18n._('Video camera icon', 'Video camera indicator icon for a Pin')}
        color="white"
        icon="video-camera"
      />
      <Box marginLeft={1}>
        <Text color="white" size="xs" truncate>
          {millisToMinutesAndSeconds(duration)}
        </Text>
      </Box>
    </Box>
  );
}
